import {useCallback, useEffect} from "react";

const emitter = new EventTarget();

export function useEvents() {
    const emit = useCallback((type: string, detail?: Record<string, unknown>) => {
        emitter.dispatchEvent(new CustomEvent(type, {detail}));
    }, []);

    const listen = useCallback((type: string, handler: (detail: Record<string, unknown>) => void) => {
        const listener = (e: Event) => handler((e as CustomEvent).detail ?? {});
        emitter.addEventListener(type, listener);
        return () => emitter.removeEventListener(type, listener);
    }, []);

    return {emit, listen};
}
